import CompleteExportTable from "./CompleteExportTable";

export default CompleteExportTable;
